<template>
  <div id='app'>
    <Topbar v-if="!$route.meta.hideTopbar" />
    <AppMain />
    <Playbar v-if="!$route.meta.hideTopbar" />
  </div>
</template>

<script>
import Topbar from '@/components/Topbar/Topbar'
import Playbar from '@/components/Playbar/Playbar'
import AppMain from '@/components/AppMain'

export default {
  name: 'App',
  components: {
    AppMain,
    Topbar,
    Playbar,
  },
  created() {
    // 检查当前 hash 路径，如果是 /#/isefc 则重定向到 /#/home
    this.checkAndRedirect();
  },
  methods: {
    checkAndRedirect() {
      const hash = window.location.hash;
      console.log("url",hash);
      if (hash === '#/isefc' || hash === '#/isefc/') {
        this.$router.push('/home');
      }
    }
  }
}
</script>

<style >
/* 自定义滚动条样式 - 契合 Element UI 主题 */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Firefox 滚动条 */
* {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f1f1f1;
}
body{
  margin: 0 !important;
}
/* *{
  font-family: 'Noto Serif SC', '思源宋体', serif;
} */
#app {
  background-color: #f5f5f5;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

</style>

